import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type UserFilter = {
  isActive: string;
  role: string;
};
const initialState: {
  filterItem: UserFilter;
  url: string;
  filterSet: boolean;
  deleteFilter: "role" | "isActive" | "";
} = {
  filterItem: {
    isActive: "",
    role: "",
  },
  url: "/?",
  filterSet: false,
  deleteFilter: "",
};

const userFilterSlice = createSlice({
  name: "userFilter",
  initialState,
  reducers: {
    setFilter: (state, action: PayloadAction<UserFilter>) => {
      state.filterItem = action.payload;
      state.deleteFilter = "";
    },
    setURL: (state) => {
      state.url = `/?is_active=${state.filterItem.isActive}&role=${state.filterItem.role}`;
    },
    removeRole: (state) => {
      state.filterItem.role = "";
      state.deleteFilter = "role";
    },
    removeStatus: (state) => {
      state.filterItem.isActive = "";
      state.deleteFilter = "isActive";
    },
    clearFilter: (state) => {
      state.filterSet = false;
      state.filterItem.isActive = "";
      state.filterItem.role = "";
      state.deleteFilter = "";
    },
    isFilterSet: (state) => {
      if (!state.filterItem.isActive && !state.filterItem.role) {
        state.filterSet = false;
      } else {
        state.filterSet = true;
      }
    },
  },
});

export const userFilterAction = userFilterSlice.actions;
export default userFilterSlice;
